import '../../css/base.css';

const EatingOut = () => {

  const redirectToSheenaFacebook = () => {
    window.open("https://www.facebook.com/Sheenas-Tea-Hut-441356046027969");
  }

  const redirectToGlenelgInn = () => {
    window.open("https://www.glenelg-inn.com");
  }

  const redirectToKintailLodgeHotel = () => {
    window.open("https://kintaillodgehotel.co.uk/glenshiel-kyle-lochalsh-skye-food/");
  }

  const redirectToHectors = () => {
    window.open("https://hectorskyle.co.uk");
  }
  
  const redirectToPlocktonTheShores = () => {
    window.open("https://plocktonshores.com");
  }

  return (
    <div className="row">
      <div className="col-12 imagesBackgroundColour">
        <div className="generalText">
          <div className="generalTextBox">
            <p className="eating-text">These are our personal recommendations.  There are many more places to try in Kyle, Plockton and Skye.  Let us know if there are any places you have enjoyed
                                        and would recommend.
            </p>                                            
          </div>
        </div>
      </div>
      <div className="col-12 col-md-6 imagesBackgroundColour">
        <div className="generalText">
          <div className="generalTextBox">
          <h2 className="walks-link-heading"><a  onClick={redirectToGlenelgInn}>Glenelg Inn</a></h2>
            <p className="eating-text">The Glenelg Inn provides a warm welcome and fabulous dining inside and out. Located right by the loch you can visit for breakfast, lunch or dinner and be assured of good food served with a view. Cosy with open fires and live music in winter, outdoor Loch side tables in summer. A good range of local beers available too. Locally caught fresh fish and seafood a specialty. Excellent gluten free and vegetarian options.
            </p>                                            
            <p className="eating-location"><strong>Location: </strong>Glenelg - 9 miles.    Phone number 01599 522273.  Booking is essential
            </p>                                            
          </div>
        </div>
      </div>
      <div className="col-12 col-md-6 imagesBackgroundColour">
        <div className="generalText">
          <div className="generalTextBox">
          <h2 className="walks-link-heading"><a  onClick={redirectToKintailLodgeHotel}>Kintail Lodge Hotel</a></h2>
            <p className="eating-text">The Kintail Lodge Hotel offers an extensive food and drinks menu with fresh daily seafood specials. This popular hotel offers a welcoming bar and restaurant located by the waters edge and the Five Sisters of Kintail mountain range provides a stunning backdrop. Excellent gluten free and vegetarian options.
            </p>                                            
            <p className="eating-location"><strong>Location: </strong>Shiel Bridge - 19 miles.      Phone number 01599 511275
            </p>                                            
          </div>
        </div>
      </div>
      <div className="col-12 col-md-6 imagesBackgroundColour">
        <div className="generalText">
          <div className="generalTextBox">
          <h2 className="walks-link-heading"><a  onClick={redirectToHectors}>Hector's Bothy</a></h2>
            <p className="eating-text">Cafe bar located in the Kyle of Localsh.  Locally sourced food and drink with excellent seafood.  Takeaway available.
            </p>                                            
            <p className="eating-location"><strong>Location: </strong>Kyle of Lochalsh - 34 miles.      Phone number 01599 534248
            </p>                                            
          </div>
        </div>
      </div>
      <div className="col-12 col-md-6 imagesBackgroundColour">
        <div className="generalText">
          <div className="generalTextBox">
            <h2 className="walks-link-heading"><a  onClick={redirectToPlocktonTheShores}>Plockton Shores Restaurant</a></h2>
            <p className="eating-text">Set in a beautiful location, serving up freshly caught local seafood.  Also serve fantasic beef and venison.
            </p>                                            
            <p className="eating-location"><strong>Location: </strong>Plockton - 37 miles.  Phone number 01599 544263
            </p>                                            
          </div>
        </div>
      </div>
    </div>
  );
}

export default EatingOut;